import React from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import config from 'config';
import styles from './DonateButton.scss';
import {
  ExperimentKeys,
  experiments as experimentConstants,
} from 'src/constants/experiments';
import { encodeBase64 } from 'src/helpers/base64';
import { Trans } from 'react-i18next';

type Props = {
  isActive: boolean;
  name: string;
  pageSection: string;
  donate: (options: { pageSection: string }) => void;
  experiments?: ExperimentKeys[];
  successType?: string;
};

function DonateButton({
  isActive,
  name,
  pageSection,
  donate,
  // Pass all the experiments by default
  experiments = Object.values(experimentConstants),
  successType = 'StaticDonateButtonClick',
}: Props) {
  const buttonClass = classNames('jg-btn', {
    'is-disabled': !isActive,
  });

  const buildQueryString = () => {
    const urlParams = new URLSearchParams();

    if (pageSection) {
      urlParams.append('pageSection', pageSection);
    }

    const trimmedSuccessType = successType.trim();
    const trimmedExperiments = experiments
      .map(e => e.trim())
      .filter(e => e !== '');

    if (
      trimmedExperiments &&
      trimmedExperiments.length > 0 &&
      trimmedSuccessType
    ) {
      urlParams.append(
        'experiments',
        encodeBase64(trimmedExperiments.join(','))
      );
      urlParams.append('successType', encodeBase64(trimmedSuccessType));
    }

    return urlParams.toString() ? `?${urlParams.toString()}` : '';
  };

  return (
    <a
      data-marker="donate-button"
      onClick={() => donate({ pageSection })}
      href={`${
        config.CROWDFUNDING_BASE_URI
      }/${name}/donate${buildQueryString()}`}
      className={buttonClass}
      styleName="fixed-donate-button"
    >
      <Trans i18nKey="Common.Donate">Give Now</Trans>
    </a>
  );
}

export default CSSModules(DonateButton, styles);



// WEBPACK FOOTER //
// ./src/components/Page/DonateButton.tsx